import { URLBuilder } from '@termly-web/common'

import useRedirectFromQueryString from 'hooks/useRedirectFromQueryString'


/**
 * Every sign-in flow lands the user in the same place, so they all share
 * this hook rather than each deciding for itself.
 *
 * Not `navigate()`: the destination can name any Termly app on this origin,
 * and each one is a separate bundle, so the dashboard's router would send a
 * Builder URL to its catch-all.
 *
 * @returns {Function} which takes the freshly signed-in user record and
 *   navigates to wherever that user belongs
 */
export default function usePostSignInRedirect() {
  const redirect = useRedirectFromQueryString()

  return (user) => {
    if ( user.must_change_password ) {
      window.location.assign(URLBuilder.accountURL())

      return
    }

    window.location.assign(redirect || URLBuilder.dashboardURL())
  }
}
